/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ArrivalQuantityPlan } from './ArrivalQuantityPlan';
import {
    ArrivalQuantityPlanFromJSON,
    ArrivalQuantityPlanFromJSONTyped,
    ArrivalQuantityPlanToJSON,
    ArrivalQuantityPlanToJSONTyped,
} from './ArrivalQuantityPlan';

/**
 * 
 * @export
 * @interface PendingOrderNextDay
 */
export interface PendingOrderNextDay {
    /**
     * 
     * @type {number}
     * @memberof PendingOrderNextDay
     */
    companyId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PendingOrderNextDay
     */
    centerId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PendingOrderNextDay
     */
    itemCode?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof PendingOrderNextDay
     */
    recDate?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof PendingOrderNextDay
     */
    orderQuantityRecommend?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof PendingOrderNextDay
     */
    orderRecommendCalcDatetime?: Date | null;
    /**
     * 
     * @type {ArrivalQuantityPlan}
     * @memberof PendingOrderNextDay
     */
    arrivalQuantityPlan?: ArrivalQuantityPlan | null;
}

/**
 * Check if a given object implements the PendingOrderNextDay interface.
 */
export function instanceOfPendingOrderNextDay(value: object): value is PendingOrderNextDay {
    return true;
}

export function PendingOrderNextDayFromJSON(json: any): PendingOrderNextDay {
    return PendingOrderNextDayFromJSONTyped(json, false);
}

export function PendingOrderNextDayFromJSONTyped(json: any, ignoreDiscriminator: boolean): PendingOrderNextDay {
    if (json == null) {
        return json;
    }
    return {
        
        'companyId': json['company_id'] == null ? undefined : json['company_id'],
        'centerId': json['center_id'] == null ? undefined : json['center_id'],
        'itemCode': json['item_code'] == null ? undefined : json['item_code'],
        'recDate': json['rec_date'] == null ? undefined : (new Date(json['rec_date'])),
        'orderQuantityRecommend': json['order_quantity_recommend'] == null ? undefined : json['order_quantity_recommend'],
        'orderRecommendCalcDatetime': json['order_recommend_calc_datetime'] == null ? undefined : (new Date(json['order_recommend_calc_datetime'])),
        'arrivalQuantityPlan': json['arrival_quantity_plan'] == null ? undefined : ArrivalQuantityPlanFromJSON(json['arrival_quantity_plan']),
    };
}

export function PendingOrderNextDayToJSON(json: any): PendingOrderNextDay {
    return PendingOrderNextDayToJSONTyped(json, false);
}

export function PendingOrderNextDayToJSONTyped(value?: PendingOrderNextDay | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'company_id': value['companyId'],
        'center_id': value['centerId'],
        'item_code': value['itemCode'],
        'rec_date': value['recDate'] == null ? value['recDate'] : value['recDate'].toISOString(),
        'order_quantity_recommend': value['orderQuantityRecommend'],
        'order_recommend_calc_datetime': value['orderRecommendCalcDatetime'] == null ? value['orderRecommendCalcDatetime'] : value['orderRecommendCalcDatetime'].toISOString(),
        'arrival_quantity_plan': ArrivalQuantityPlanToJSON(value['arrivalQuantityPlan']),
    };
}

